import { createContext, useContext, useEffect, useState } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const AdminAuthContext = createContext(null);

export function formatApiError(error) {
  if (!error) return "Something went wrong. Please try again.";
  if (typeof error === "string") return error;
  if (Array.isArray(error)) return error.map((item) => item.msg || "Invalid input").join(" ");
  return error.msg || String(error);
}

export async function apiRequest(path, options = {}) {
  const response = await fetch(`${API}${path}`, {
    credentials: "include",
    headers: { "Content-Type": "application/json", ...options.headers },
    ...options,
  });
  const body = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(formatApiError(body.detail));
  return body;
}

export function AdminAuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [setupNeeded, setSetupNeeded] = useState(false);
  const [ready, setReady] = useState(false);

  const refreshSession = async () => {
    const setup = await apiRequest("/auth/setup-status");
    setSetupNeeded(setup.needs_setup);
    if (!setup.needs_setup) {
      try { setUser(await apiRequest("/auth/me")); } catch { setUser(null); }
    }
    setReady(true);
  };

  useEffect(() => { refreshSession().catch(() => setReady(true)); }, []);

  const value = { user, setUser, setupNeeded, setSetupNeeded, ready, refreshSession };
  return <AdminAuthContext.Provider value={value}>{children}</AdminAuthContext.Provider>;
}

export function useAdminAuth() {
  return useContext(AdminAuthContext);
}